export default __webpack_public_path__ + "static/media/img_13.e3830eef.JPG";